export default __webpack_public_path__ + "static/media/logotrilhasup.f4d27dd6.png";